import { render } from "./AbsibSimpleIcon.vue?vue&type=template&id=800fe55a&ts=true"
import script from "./AbsibSimpleIcon.vue?vue&type=script&lang=ts"
export * from "./AbsibSimpleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__